import React from 'react';
import PropTypes from 'prop-types';

import Grid from '~/components/core/Atomic/Grid/Grid';

import SumCard from './SumCard';

import styles from '../financesScreen.module.scss';

const SumsHeader = ({ amounts, shouldDisplayOnlyHeader, displayNetAmounts }) => {
  // The net claim totals are null on a response the server did not compute them for, so fall back to
  // the gross figure instead of rendering an empty card. Reserves are recorded net already and so have
  // no net variant — that card is identical either way.
  const amount = (netAmount, grossAmount) => (displayNetAmounts ? (netAmount ?? grossAmount) : grossAmount);

  return (
    <Grid container spacing={3}>
      <Grid item xs={4}>
        <SumCard
          header={displayNetAmounts ? 'Net Paid to Date Claim Total' : 'Paid to Date Claim Total'}
          expensesAmount={amount(amounts.net_expenses_paid_sum, amounts.expenses_paid_sum)}
          indemnityAmount={amount(amounts.net_indemnity_paid_sum, amounts.indemnity_paid_sum)}
          shouldDisplayOnlyHeader={shouldDisplayOnlyHeader}
        />
      </Grid>
      <Grid item xs={4}>
        <SumCard
          header="Reserve to Date Claim Total"
          expensesAmount={amounts.expenses_reserve}
          indemnityAmount={amounts.indemnity_reserve}
          shouldDisplayOnlyHeader={shouldDisplayOnlyHeader}
        />
      </Grid>
      <Grid item xs={4}>
        <SumCard
          className={styles.incurredSumCard}
          header={displayNetAmounts ? 'Net Incurred Claim Total' : 'Incurred Claim Total'}
          expensesAmount={amount(amounts.net_expenses_incurred, amounts.expenses_incurred)}
          indemnityAmount={amount(amounts.net_indemnity_incurred, amounts.indemnity_incurred)}
          shouldDisplayOnlyHeader={shouldDisplayOnlyHeader}
        />
      </Grid>
    </Grid>
  );
};

SumsHeader.propTypes = {
  amounts: PropTypes.object,
  shouldDisplayOnlyHeader: PropTypes.bool,
  displayNetAmounts: PropTypes.bool,
};

export default SumsHeader;
